<template>
  <div class="product_detail">
    <div class="common_mbx">
      您当前的位置：
      <router-link to='/index' tag='span'>
        首页
      </router-link>
      <template v-for='(item,index) in parent'>
        <router-link to='/product' v-if='index==0' tag='span'>
           >{{item.name}}
        </router-link>
       <router-link :to='"/product/list/"+item.id' v-if='index==1' tag='span'>
           >{{item.name}}
        </router-link>
        <router-link :to='"/product/list2/"+item.id' v-if='index==3' tag='span'>
           >{{item.name}}
        </router-link>
        <!-- <router-link to='/product' v-if='index==3'>
           >{{item.name}}
        </router-link> -->
      </template>
      <!-- > 面盆洁具
      > DKING【水龙头】意大利fir -->
    </div>
    <div class="detail_top clearfix">
      <div class="detail_top_left">
        <img :src="domain+data.pictureurls" v-if='data.pictureurls'>
        <img :src="domain+data.litpic" v-if='!data.pictureurls'>
      </div>
      <div class="detail_top_right">
        <p class="p_name">{{data.title}}</p>
        <div class="p_options">
          <div class="p_option clearfix">
            <div class="p_item">所属品类：{{cate.name}}</div>
            <div class="p_item">品牌：{{data.brand}}</div>
          </div>
          <div class="p_option clearfix">
            <div class="p_item">系列：{{data.series}}</div>
            <div class="p_item">型号：{{data.model}}</div>
          </div>
          <div class="p_option clearfix">
            <div class="p_item">规格：{{data.specification}}</div>
            <div class="p_item">颜色：{{data.color}}</div>
          </div>
          <div class="p_option clearfix">
            <div class="p_item">材质：{{data.material}}</div>
            <div class="p_item">使用人数：{{data.nums}}</div>
          </div>
          <div class="p_option clearfix">
            <div class="p_item">设计师：{{data.designer}}</div>
            <div class="p_item">产地：{{data.area}}</div>
          </div>
          <div class="p_option clearfix">
            <div class="p_item">货期：{{data.updatetime}}</div>
            <div class="p_item">安装方式：{{data.installation}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div class="content_top">
        <div class="content_title">产品详情</div>
      </div>
      <div class="p_content" v-html='data.content'>
 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      data:'',
      cate:'',
      domain:'',
      parent:[]
    }
  },
  watch:{
    '$route':function(to,from){
      this.getDetail()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain

    this.getDetail()
  },
  methods:{
    getparent:function(id){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_parent', this.$qs.stringify({
        cid:id
      }))
      .then(response => {
        console.log(response);
        this.parent=response.data.data
        //console.log(this.parent)
        /*this.cate=response.data.cate*/
      })
      .catch(error => {
        console.log(error);
      });
    },
    getDetail:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_product_detail', this.$qs.stringify({
        id:this.$route.params.id
      }))
      .then(response => {
        console.log(response);
        this.data=response.data.data
        this.cate=response.data.cate
        this.getparent(this.cate.id)


      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>
  .product_detail{
    width: 1200px;
    margin: 0 auto;
  }
  .common_mbx{
    padding: 38px 0 33px 0;
    font-size: 14px;
    color: #383838;
  }
  .common_mbx span{
    cursor: pointer;
  }
  .detail_top{
    margin-bottom: 50px;
  }
  .detail_top_left{
    width: 600px;
    float: left;
  }
  .detail_top_right{
    width: 600px;
    float: left;
    padding-left: 60px;
    box-sizing: border-box;
  }
  .p_name{
    color: #020202;
    font-size: 30px;
  }
  .p_option{
    padding: 24px 0;
    border-bottom: 1px dashed #d5d5d5;
  }
  .p_option:last-child{
    border-bottom: none;
  }
  .p_item{
    width: 50%;
    float: left;
    font-size: 14px;
    color: #020202;
  }
  .content_top{
    border-bottom: 1px solid #d4d4d4;
    box-sizing: border-box;
  }
  .content_top div{
    padding-bottom: 24px;
    width: 200px;
    text-align: center;
    font-size: 14px;
    color: #3478f7;
    border-bottom: 2px solid #3478f7;
    position: relative;
    top: 1px;
  }
  .p_content img{
    max-width: 100%;
  }
  .p_content{
    padding: 36px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/product_detail.vue